// Vendors
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// Components
import { Trans } from '../../..';
import { TextButton } from 'texkit/dist/components/Buttons';
// Actions
import { openModal } from '../../../../reducers/modal/modalActions';

// Selectors
import { selectAgencyByRouteParam } from '../../../../reducers/agency/agencySelectors';

const DPSFooter = ({
  agency: { agencySlug = '' },
  updateEmergencyFlag,
  renewalFlag,
  renewAddressChangeFlag,
}) => {
  const dispatch = useDispatch();

  const getType = () => {
    if (updateEmergencyFlag) return 'EMERGENCY';
    else if (renewalFlag) return 'RENEWAL';
    else if (renewAddressChangeFlag) return 'REPLACEMENT';
    else if (agencySlug === 'dps') return 'DLR';
  };

  const modal = {
    DLR: 'DPSFAQModal',
    EMERGENCY: 'DPS_EMERGENCY_FAQModal',
    RENEWAL: 'DPS_Renewal_FAQModal',
    REPLACEMENT: 'DPS_REPLACEMENT_FAQModal',
  };
  const id = {
    DLR: 'FAQ',
    EMERGENCY: 'FAQ_EMERGENCY',
    RENEWAL: 'FAQ_DRIVER_LICENSE_ID',
    REPLACEMENT: 'FAQ_DRIVER_LICENSE_ID',
  };

  return updateEmergencyFlag ||
    agencySlug === 'dps' ||
    renewalFlag ||
    renewAddressChangeFlag ? (
    <li className="footer-nav-list-item">
      <TextButton as="a" onClick={() => dispatch(openModal(modal[getType()]))}>
        <Trans file="Common" id={id[getType()]} />
      </TextButton>
    </li>
  ) : null;
};

const mapStateToProps = (state, props) => ({
  agency: selectAgencyByRouteParam(state, props),
  updateEmergencyFlag: state.dps.updateEmergencyFlag,
  renewalFlag: state.dps.renewalFlag,
  renewAddressChangeFlag: state.dps.renewAddressChangeFlag,
});

DPSFooter.propTypes = {
  agency: PropTypes.object,
  agencySlug: PropTypes.string,
  updateEmergencyFlag: PropTypes.bool.isRequired,
  renewAddressChangeFlag: PropTypes.bool.isRequired,
  renewalFlag: PropTypes.bool.isRequired,
};

export default memo(withRouter(connect(mapStateToProps, null)(DPSFooter)));
